import axios from 'axios';
import { Remote } from '@/util';

class CouponOrderService {
  queryList(params = {}) {
    return Remote.post('/marketcuponbag/queryShareAndPay', params);
  }

  queryShopList(params = {}) {
    return Remote.get('/activityDic/allMerchantShopList.do', params);
  }

  queryOrderStatusOptions(params = {}) {
    return Remote.get('/marketcuponbag/getOrderStatusList', params);
  }

  queryActivity(params = {}) {
    return Remote.get('/marketcuponbag/queryShardActivityList', params);
  }

  exportToExcelByCondition(data = {}) {
    const accessToken = localStorage.getItem('accessToken');
    const host = Remote.genDomainForEnv('default');
    const url = `${host}/marketcuponbag/exportShareAndPay`;
    return axios.post(url, data, {
      headers: {
        'content-type': 'application/json',
        token: accessToken,
      },
      responseType: 'blob',
    });
  }

  // 根据oneId查询手机号查看次数
  getPhoneViewApply(params) {
    return Remote.get('/userinfo/queryPhoneByUniqueCode', params, { urlType: 'userCenter' });
  }

  // 根据oneId查询手机号
  getPhoneViewBehavior(params) {
    return Remote.get('/userinfo/queryCurrentUserViewPhoneUsableCount', params, { urlType: 'userCenter' });
  }
}

export default new CouponOrderService();
